import React from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    title: {
        margin: theme.spacing(0, 0, 2),
        fontSize: 20,
        color: '#666'
    },
}));

export const Subtitle = ({ children, style }) => {
  const classes = useStyles();
  return ( <Typography variant="h5" style={style} gutterBottom className={classes.title} >{children}</Typography> );
}

export default Subtitle;